import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const currencySymbol = (c) => ({ USD: "$", EUR: "€", INR: "₹", GBP: "£", JPY: "¥" }[c] || "$");

export const fmtMoney = (v, cur = "USD") => {
  const num = Number(v || 0);
  return `${currencySymbol(cur)}${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const CATEGORY_ICONS = {
  Food: "utensils",
  Rent: "home",
  "Utility Bills": "zap",
  Transport: "car",
  Shopping: "shopping-bag",
  Entertainment: "film",
  Health: "heart-pulse",
  Education: "book-open",
  Salary: "briefcase",
  Freelance: "laptop",
  Investment: "trending-up",
  Gift: "gift",
  Other: "circle",
};
